<template>
  <div class="page-container">
    <div class="row mt-4">
      <div class="query-box col-4">
        <div class="label">วันที่ปิดงาน</div>
        <date-picker
          v-model="query.fulfilledDate"
          type="daterange"
          style="width: 100%"
        ></date-picker>
      </div>
      <div class="query-box col-3">
        <div class="label">PO SAP</div>
        <el-input
          type="text"
          v-model="query.poNumber"
          placeholder="ex. 8100001653"
        ></el-input>
      </div>
      <div class="query-box col-2">
        <div class="label">เลขที่ใบเสร็จ/ใบกำกับ</div>
        <el-input type="text" v-model="query.documentNumber"></el-input>
      </div>
      <div class="query-box col-3">
        <div class="label">ผู้ให้บริการ</div>
        <provider-selector v-model="query.provider"></provider-selector>
      </div>
      <div class="query-box col-4">
        <div class="label">วันที่ใบเสร็จจาก vender</div>
        <date-picker
          v-model="query.venderReceiptDate"
          type="daterange"
          style="width: 100%"
        ></date-picker>
      </div>
      <div class="query-box col-5">
        <div class="label">เลขที่ใบเสร็จจาก Vendor</div>
        <el-input type="text" v-model="query.documentVenderNumber"></el-input>
      </div>
    </div>
    <div class="remark">
      *ถ้าเป็นบริการปลวกที่นัดรับครั้งแรก ต้องแจ้งให้ทีม TS manual ส่ง SAP ให้
      ไม่สามารถแก้ไขส่งเองได้
    </div>
    <div class="mb-2 text-right">
      <sc-button variant="warning" @click="handleClickClear">clear</sc-button>
    </div>
    <div class="text-right">
      <sc-button variant="primary" @click="handleClickSearch">ค้นหา</sc-button>
    </div>
    <div class="report-container">
      <div class="csv mb-3">
        <button variant="secondary" @click.prevent="handleClickDownloadAsCSV">
          Download
        </button>
      </div>
      <div class="row mb-1">
        <div class="col-6">{{ totalCount }}</div>
        <div class="col-6">
          <el-pagination
            class="right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="query.take"
            :current-page="query.page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <div class="report">
        <div
          class="vender-report-row"
          :class="{ header: index === 0 }"
          v-for="(venderReport, index) in sapVenderReportPresenters"
          :key="index"
        >
          <div class="report-cell tiny">
            {{ venderReport.uuid }}
          </div>
          <div class="report-cell">
            <pre class="report-billing">{{ venderReport.receiptAddress }}</pre>
          </div>
          <div class="report-cell">
            {{ venderReport.poNumber }}
          </div>
          <div class="report-cell">
            {{ venderReport.poItem }}
          </div>
          <div class="report-cell text-center">
            <router-link
              class="router-link"
              target="_blank"
              :to="{
                name: 'ReceiptDetailPage',
                params: {
                  id: venderReport.receiptId,
                },
              }"
              >{{ venderReport.receiptNumber }}</router-link
            >
          </div>
          <div class="report-cell">
            {{ venderReport.serviceName }}
          </div>
          <div class="report-cell">
            {{ venderReport.sapServiceType }}
          </div>
          <div class="report-cell">
            {{ venderReport.vendorName }}
          </div>
          <div class="report-cell">
            {{ venderReport.fulfilledAt }}
          </div>
          <div class="report-cell">
            {{ venderReport.receiptAppointmentDate }}
          </div>
          <div class="report-cell">
            {{ venderReport.receiptAppointmentNumber }}
          </div>
          <div class="report-cell">
            {{ venderReport.actualCost }}
          </div>
          <div class="report-cell">
            {{ venderReport.sapActualCost }}
          </div>
          <div class="report-cell">
            <router-link
              target="_blank"
              class="router-link"
              v-if="venderReport.appointmentId"
              :to="{
                name: 'AppointmentDetailPage',
                params: { id: venderReport.appointmentId },
              }"
              >กดเพื่อดูนัดหมาย</router-link
            >
          </div>
          <div class="report-cell center">
            <div v-if="index === 0">แก้ไข</div>
            <div v-else>
              <sc-button
                variant="warning"
                size="m"
                @click="handleClickEditAppointmentProvider(venderReport)"
                >แก้ไขข้อมูล Vendor</sc-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-1 mt-1">
        <div class="col-12">
          <el-pagination
            class="right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="query.take"
            :current-page="query.page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div>
      <confirm
        name="confirmProvider"
        v-show="confirmProviderDialog.isShow"
        :data="confirmProviderDialog.data"
      >
        <appointment-vender-receipt
          @cancel="
            (confirmProviderDialog.isShow = false),
              (confirmProviderDialog.params = null)
          "
          :value="confirmProviderDialog.params"
        ></appointment-vender-receipt>
      </confirm>
    </div>
  </div>
</template>
  
  <script>
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";
import { Select, Option, Input, Pagination } from "element-ui";
import ProjectSelect from "@/lib/components/ProjectSelect";
import ProviderSelector from "../../../lib/components/ProviderSelector.vue";

import {
  convertCamelToSnake,
  existValueAndEmptyString,
  filterNonNull,
} from "../../../lib/util";
import AppointmentVenderReceipt from "../../../lib/components/AppointmentVenderReceipt.vue";
import { convertBathToStangAndRoundTwoDecimal } from "../../../lib/formatter";
import { convertDateTimeToTimeText } from "@/lib/dateTime";

export default {
  components: {
    PageWrapper,
    DatePicker,
    ScButton,
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
    ProjectSelect,
    ProviderSelector,
    AppointmentVenderReceipt,
    "el-pagination": Pagination,
  },
  data() {
    const query = {
      fulfilledDate: [],
      fulfilledDateTo: null,
      fulfilledDateForm: null,
      poNumber: null,
      documentNumber: null,
      provider: null,
      venderReceiptDate: [],
      venderReceiptDateTo: null,
      venderReceiptDateForm: null,
      documentVenderNumber: null,
      page: 1,
      take: 20,
    };

    return {
      query,
      sapVenderReports: [],
      confirmProviderDialog: {
        isShow: false,
        data: {
          title: "แก้ไขข้อมูล Vendor รายนัดหมาย",
        },
        params: null,
      },
      total: 0,
    };
  },
  computed: {
    sapVenderReportPresenters() {
      const header = {
        uuid: "UUID",
        receiptAddress: "ข้อมูลที่ออกใบเสร็จ",
        poNumber: "PO SAP",
        poItem: "PO ITEM",
        receiptNumber: "เลขที่ใบเสร็จ",
        serviceName: "บริการ",
        sapServiceType: "ประเภทของสินค้าและบริการ (SAP)",
        vendorName: "ผู้ให้บริการรายนัดหมาย",
        fulfilledAt: "วันที่ปิดงาน",
        receiptAppointmentDate: "วันที่ใบเสร็จจาก Vendor",
        receiptAppointmentNumber: "เลขที่ใบเสร็จจาก Vendor",
        actualCost: "ต้นทุนจริง",
        sapActualCost: "ต้นทุนจริงส่ง sap",
      };

      return [header, ...this.sapVenderReports];
    },
    queryParams() {
      const {
        fulfilledDateTo,
        fulfilledDateForm,
        poNumber,
        documentNumber,
        provider,
        venderReceiptDateTo,
        venderReceiptDateForm,
        documentVenderNumber,
        page,
      } = this.$route.query;

      const queryParams = {
        fulfilledDateTo,
        fulfilledDateForm,
        poNumber,
        documentNumber,
        provider,
        venderReceiptDateTo,
        venderReceiptDateForm,
        documentVenderNumber,
        page,
      };

      return convertCamelToSnake(filterNonNull(queryParams));
    },
    totalCount() {
      const limit = this.query.take;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.sapVenderReports.length;

      const isLastPage = limit > currentTotalItem;
      const currentPage = +this.query.page || 1;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
  },
  created() {
    this.setup();
  },
  watch: {
    "$route.query"() {
      this.setup();
    },
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const {
        fulfilledDateTo,
        fulfilledDateForm,
        poNumber,
        documentNumber,
        provider,
        venderReceiptDateTo,
        venderReceiptDateForm,
        documentVenderNumber,
        page,
      } = this.$route.query;

      this.query = {
        poNumber: poNumber || null,
        documentNumber: documentNumber || null,
        provider: provider || null,
        documentVenderNumber: documentVenderNumber || null,
        fulfilledDate: [],
        venderReceiptDate: [],
        fulfilledDateForm: fulfilledDateForm || null,
        fulfilledDateTo: fulfilledDateTo || null,
        venderReceiptDateTo: venderReceiptDateTo || null,
        venderReceiptDateForm: venderReceiptDateForm || null,
        page: +page || 1,
        take: 20,
      };

      if (
        existValueAndEmptyString(fulfilledDateForm) &&
        existValueAndEmptyString(fulfilledDateTo)
      ) {
        this.query.fulfilledDate = [
          DateTime.fromISO(fulfilledDateForm),
          DateTime.fromISO(fulfilledDateTo),
        ];
      }

      if (
        existValueAndEmptyString(venderReceiptDateTo) &&
        existValueAndEmptyString(venderReceiptDateForm)
      ) {
        this.query.venderReceiptDate = [
          DateTime.fromISO(venderReceiptDateForm),
          DateTime.fromISO(venderReceiptDateTo),
        ];
      }
    },
    handleClickSearch() {
      let fulfilledDateForm;
      let fulfilledDateTo;
      if (this.query.fulfilledDate && this.query.fulfilledDate.length > 1) {
        fulfilledDateForm = this.query.fulfilledDate[0].toISO();
        fulfilledDateTo = this.query.fulfilledDate[1].toISO();
      }

      let venderReceiptDateForm;
      let venderReceiptDateTo;
      if (
        this.query.venderReceiptDate &&
        this.query.venderReceiptDate.length > 1
      ) {
        venderReceiptDateForm = this.query.venderReceiptDate[0].toISO();
        venderReceiptDateTo = this.query.venderReceiptDate[1].toISO();
      }

      const provider =
        existValueAndEmptyString(this.query.provider) && this.query.provider.id
          ? this.query.provider.id
          : this.query.provider;

      this.query = {
        ...this.query,
        fulfilledDateForm,
        fulfilledDateTo,
        venderReceiptDateForm,
        venderReceiptDateTo,
        provider,
      };

      this.$router.push({ query: this.query });
    },
    handleClickClear() {
      this.query = {
        fulfilledDate: [],
        fulfilledDateTo: null,
        fulfilledDateForm: null,
        poNumber: null,
        documentNumber: null,
        provider: null,
        venderReceiptDate: [],
        venderReceiptDateTo: null,
        venderReceiptDateForm: null,
        documentVenderNumber: null,
        page: 1,
      };
    },
    async setupData() {
      await this.setupSapVenderReports();
    },
    async setupSapVenderReports() {
      const { reports, count } = await this.fetchSapVenderReports();

      this.total = count;
      this.sapVenderReports = reports.map((sap) => {
        return {
          ...sap,
          uuid: sap.uuid,
          receiptAddress: sap.receipt_address,
          poNumber: sap.po_number,
          poItem: sap.po_item,
          receiptNumber: sap.rec_no,
          serviceName: sap.ser_nam,
          sapServiceType: sap.appointment.service.sap_service_type,
          vendorName: sap.vendor_nam,
          fulfilledAt: convertDateTimeToTimeText(
            sap.appointment.fulfilled_at,
            "dd MMM yyyy"
          ),
          receiptAppointmentDate: convertDateTimeToTimeText(
            sap.appointment.receipt_date,
            "dd MMM yyyy"
          ),
          receiptAppointmentNumber: sap.appointment.receipt_number,
          actualCost: convertBathToStangAndRoundTwoDecimal(
            sap.appointment.actual_cost
          ),
          receiptId: sap.appointment.subscription.receipt.id,
          providerId: sap.appointment.provider_id.toString(),
          receiptDate: sap.appointment.receipt_date,
          appointmentId: sap.appointment.id,
          sapActualCost: convertBathToStangAndRoundTwoDecimal(
            sap.price
          )
        };
      });
    },
    async fetchSapVenderReports() {
      const response = await baanRueJaiClient.admin.sap.getSapVenderReportList(
        this.queryParams
      );

      return response.data.result;
    },

    async handleClickDownloadAsCSV(event) {
      event.preventDefault();
      const response = await baanRueJaiClient.admin.sap.getSapVenderReportList({
        ...this.queryParams,
        format: "xlsx",
      });

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `sap-vender-reports.xlsx`;
      link.click();
    },
    handleClickEditAppointmentProvider(sapSelect) {
      this.confirmProviderDialog.params = {
        appointmentId: sapSelect.appointment_id,
        receiptAppointmentDate: sapSelect.receiptDate,
        receiptAppointmentNumber: sapSelect.receiptAppointmentNumber,
        actualCost: sapSelect.actualCost,
        providerId: sapSelect.providerId,
        poNumber: sapSelect.poNumber, 
        receiptNumber: sapSelect.receiptNumber, 
        isEditAfterSentToSap: true,
      };

      this.confirmProviderDialog.isShow = true;
    },
    handleCurrentChange(page) {
      const query = { ...this.$route.query, page };

      this.$router.push({ query });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
@import "~@/lib/scss/variables";
.report-container {
  padding: 0 0;
  width: 100%;
}

.vender-report-row {
  display: grid;
  grid-template-columns:
    350px
    450px
    200px
    200px
    200px
    450px
    250px
    350px
    230px
    230px
    250px
    200px
    200px
    200px
    200px;
}

.vender-report-row:first-child {
  position: sticky;
  top: 0;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
    font-size: 16px;
  }
}

.report-cell {
  padding: 10px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);
}

.receipt-link {
  font-size: 16px;
}

.query-box {
  margin-bottom: 15px;
}

pre.report-billing {
  white-space: pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  font-family: sans-serif;
  font-size: 14pt;
  color: #4a4a4a;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.router-link {
  cursor: pointer;
  text-decoration: underline;
}

.tiny {
  font-size: 15px;
}

.remark {
  font-size: 15px;
  color: red;
}
</style>
  


// WEBPACK FOOTER //
// src/features/sap/component/SapPoList.vue